import { Trans, useTranslation } from 'react-i18next';

import {
  BoldWrapper,
  ConsiderationsList,
  ConsiderationsWrapper,
  ItemsWrapper,
  TitleWrapper,
  Wrapper
} from './ImportInstructions.styles';

import { ManagerQuizzesTranslations } from '@/pages/Manager';

export const ImportInstructions = () => {
  const { t } = useTranslation('ManagerQuizzesTranslations');

  return (
    <Wrapper>
      <ItemsWrapper>
        {Array.from({ length: 4 }).map((_, index) => (
          <li key={index}>
            <Trans
              i18nKey={
                `ManagerQuizzesTranslations:IMPORT_INSTRUCTIONS_${
                  index + 1
                }` as keyof typeof ManagerQuizzesTranslations
              }
              components={{ a: <BoldWrapper /> }}
            />
          </li>
        ))}
      </ItemsWrapper>
      <ConsiderationsWrapper>
        <TitleWrapper>{t('CONSIDERATIONS')}</TitleWrapper>
        <ConsiderationsList>
          <li>
            <Trans
              i18nKey="ManagerQuizzesTranslations:QUIZ_CONSIDERATIONS_1"
              components={{ a: <BoldWrapper /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="ManagerQuizzesTranslations:QUIZ_CONSIDERATIONS_2"
              components={{ a: <BoldWrapper /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="ManagerQuizzesTranslations:QUIZ_CONSIDERATIONS_3"
              components={{ a: <BoldWrapper /> }}
            />
          </li>
          <li>
            <Trans
              i18nKey="ManagerQuizzesTranslations:REVIEW_CONSIDERATIONS"
              components={{ a: <BoldWrapper /> }}
            />
          </li>
        </ConsiderationsList>
      </ConsiderationsWrapper>
    </Wrapper>
  );
};
